import type { IconSvgObject } from './types';

const Bread02Icon: IconSvgObject = [
  ["path", { d: "M7 7C4.23858 7 2 9.23858 2 12V15C2 16.1046 2.89543 17 4 17H12V12C12 9.23858 9.76142 7 7 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 17H20C21.1046 17 22 16.1046 22 15V12C22 9.23858 19.7614 7 17 7H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 13.5C5.5 11.567 6.17157 10 7 10C7.82843 10 8.5 11.567 8.5 13.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Bread02Icon;
